module.exports = __webpack_public_path__ + "media/images/icon__paginationArrows-06a3813986b5d27ac68bc810b89c6630.png";